import React from 'react'

class NumberCell extends React.Component {
    render() {

        let classname='reducer-tieup-cell reducer-number-cell'
        if (this.props.isVertical) {
            classname='reducer-tieup-cell reducer-number-cell reducer-number-cell-vertical'
        }

        return (
            <div className = {classname} >{ this.props.cellData }</div>
        )
    }
}

export default NumberCell




// WEBPACK FOOTER //
// ./src/scenes/reducer/components/NumberCell/index.js